import { createAxiosInstance } from '@kc-console/core';

import env from '../../utils/env';
import { getTranslationFallbackFetchers } from './getTranslationFallbackFetchers';

const translationFallbackApiInstance = () => {
  const fallbackEndpoint = env.KC_TRANSLATION_FALLBACK_ENDPOINT || '';
  const axiosInstance = createAxiosInstance({
    baseURL: fallbackEndpoint,
    isCancel: !fallbackEndpoint,
  });
  return getTranslationFallbackFetchers(axiosInstance);
};

export default translationFallbackApiInstance;
